import styled from "styled-components";

export const BuscadorTurnoContainer = styled.div`
  width: 100vw;
  .btn-VerificaOs {
    border-radius: 8px;
  }
`;
export const BuscadorTurnoBody = styled.div`
  /* padding-top: 34px; */
  padding-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
export const BuscadorTurnoHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .BuscadorTurno-input-container {
    position: relative;
    width: 630px;
  }
  .BuscadorTurno-pacienteSeleccionado {
    position: absolute;
    top: 14px;
    left: 640px;
    width: 350px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    color: #023755;
  }
  .BuscadorTurno-pacienteSeleccionado-bold{
    font-weight: bold;
  }
`;
export const BuscadorTurnoGrid = styled.div``;

export const BuscadorTurnoCurva = styled.div`
  background-color: var(--color-latex10);
  height: 40px;
  border-radius: 50%;
  width: 120vw;
  position: absolute;
  top: -20px;
  background-color: var(--color-latex10);
`;
export const BuscadorTurnoFooter = styled.div`
  background-color: var(--color-latex10);
  height: 200px;
  width: 100vw;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0;
`;

export const BuscadorTurnoTecladoContainer = styled.div`
  width: 808px;
  z-index: 1;
`;
